import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import InternalAlertFormHOC from './internalAlertFormHOC';
import { createInternalAlert } from '../../reducers/internalAlertForm';
import { push } from 'connected-react-router';
import usePrevious from '../../hooks/usePrevious';

const InternalAlertsFormCreateHOC = (props) => {
    const dispatch = useDispatch();

    const internalAlertForm = useSelector(state => state.internalAlertForm);
    const prevPosting = usePrevious(internalAlertForm.posting);
    useEffect(() => {
        if (prevPosting && !internalAlertForm.posting &&
            internalAlertForm.response === 'Internal Alert was created successfully' && internalAlertForm.badResponse === '') {
            dispatch(push("/internal-alerts"));
        }
    }, [prevPosting, internalAlertForm.posting, internalAlertForm.response, internalAlertForm.badResponse])
    const submitInternalAlert = () => {
        const body = {
            solicitorFirmId: internalAlertForm.formData.solicitorFirmId,
            caseTypeId: internalAlertForm.formData.selectedCaseType,
            subCaseTypeId: internalAlertForm.formData.selectedSubCaseType === '' || internalAlertForm.formData.selectedSubCaseType == 0 ? null : internalAlertForm.formData.selectedSubCaseType,
            internalAlertText: internalAlertForm.formData.internalAlertText,
            validFrom: new Date(Date.UTC(internalAlertForm.formData.validFrom.getFullYear(), internalAlertForm.formData.validFrom.getMonth(), internalAlertForm.formData.validFrom.getDate(), 0, 0, 0, 0)).toISOString(),
            validTo: internalAlertForm.formData.validTo ? new Date(Date.UTC(internalAlertForm.formData.validTo.getFullYear(), internalAlertForm.formData.validTo.getMonth(), internalAlertForm.formData.validTo.getDate(), 23, 59, 59, 0)).toISOString() : null
        }
        dispatch(createInternalAlert(body));
    }
    return (
        <InternalAlertFormHOC
            isEdit={false}
            handleSubmit={submitInternalAlert}
            handleDelete={() => null}
        />
    )
}
export default InternalAlertsFormCreateHOC;
